import { Button, type ButtonProps } from "@-/dev.improve.haniverse.components.ui.button";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";

export type LevelsTopbarFilterButtonProps = Pick<ButtonProps, "disabled" | "onPress">;

export function LevelsTopbarFilterButton({ disabled, onPress }: LevelsTopbarFilterButtonProps) {
  return (
    <Button
      accessibilityLabel="Filter cards"
      disabled={disabled}
      onPress={onPress}
      size="icon"
      variant="outline"
    >
      <Icon color="#111827" name="MdTune" size={22} />
    </Button>
  );
}
